import { render } from "./WhatsappBuuble.vue?vue&type=template&id=ecc22cc2&scoped=true&ts=true"
import script from "./WhatsappBuuble.vue?vue&type=script&lang=ts"
export * from "./WhatsappBuuble.vue?vue&type=script&lang=ts"

import "./WhatsappBuuble.vue?vue&type=style&index=0&id=ecc22cc2&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecc22cc2"]])

export default __exports__